import {
  GetConfigEventsRequestQueryParamType,
  GetConfigEventsResponseBodyType,
} from "@intelligems/ig-types";
import { useSuspenseQuery } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { historyKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const getConfigEvents = async (
  payload: ApiRequest<any, any, GetConfigEventsRequestQueryParamType>
) => {
  const resp = await api.get<GetConfigEventsResponseBodyType>(
    `/v2/configs/events`,
    {
      params: { ...payload.queryParams },
    }
  );
  return resp.data;
};
export const useGetConfigEvents = (
  params: {
    startTs?: number;
    endTs?: number;
  },
  options?: QueryOptions<GetConfigEventsResponseBodyType, Error>
) => {
  return useSuspenseQuery<GetConfigEventsResponseBodyType, Error>({
    ...options,
    queryKey: historyKeys.configEvents(params.startTs, params.endTs),
    queryFn: async () =>
      getConfigEvents({
        body: undefined,
        queryParams: {
          startTs: params.startTs,
          endTs: params.endTs,
        },
        pathParams: undefined,
      }),
  });
};
